import { LIST_CONSTANTS } from "@/modules/List/constants/ListConstants";
import { ListService } from "@/modules/List/services/ListService";
import Vuetify from "vuetify";
import Component from "vue-class-component";
import { Inject, Prop, Vue } from "vue-property-decorator";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { Http } from "@status/codes";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { DashboardFilter } from "../../models/DashboardFilter";
import { AxiosError } from "axios";
import { SERVICE_TEMPLATES_ACCESS } from "@/modules/ServiceTemplate/constants/ServiceTemplateConstants";
import { FORM_MESSAGES } from "@/shared/constants/FormConstants";
import {
  CANCEL_BTN,
  CANCEL_CHANGE_SERVICE_STATE,
  CHANGE_STATE_EVENT,
  DASHBOARD_LABELS
} from "../../constants/AdminDashboardConstants";
import { SELECT_ACTION } from "../../constants/ActionConstants";

Vue.use(Vuetify);
@Component({
  name: "ChangeStateAction",
  components: {
    DynamicSelect
  }
})
export default class ChangeStateAction extends Vue {
  @Prop() collection!: string;
  @Prop() filters!: DashboardFilter;
  @Prop() totalItems!: number;
  @Inject() listService!: ListService;

  CANCEL_BTN = CANCEL_BTN;
  SELECT_ACTION = SELECT_ACTION;
  cardClass = STYLE_CLASSES.CARD;
  state: DynamicSelectData[] = [];
  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  changeStateForm = false;
  changeStateConfigList: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: [],
    messageLabel: DASHBOARD_LABELS.SELECT_STATE,
    hint: "",
    persistenthint: false,
    required: true,
    chips: false,
    loadingData: false,
    attach: false
  };

  collections: { [key: string]: string } = {
    services: LIST_CONSTANTS.SERVICE_STATES_LIST_NAME
  };
  async mounted() {
    await this.getStates();
  }

  async getStates() {
    try {
      const listStatesResponse = await this.listService.getListOptionsByName(
        this.collections[this.collection]
      );

      if (listStatesResponse.code == Http.Found) {
        let statesList = listStatesResponse.data!.map(item => ({
          id: item.value,
          name: item.title
        }));

        if (this.filters.allSelectFilter?.state) {
          const states = this.filters.allSelectFilter!.state;
          statesList = statesList.filter(
            state => !states.includes(state.id as any)
          );
        }
        this.changeStateConfigList.listAll = statesList;
        return;
      }

      Snackbar.popError(listStatesResponse.message);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + SERVICE_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  changeState() {
    this.$emit(
      CHANGE_STATE_EVENT,
      this.state[0].id,
      this.changeStateConfigList.listAll
    );
  }

  cancel() {
    this.$emit(CANCEL_CHANGE_SERVICE_STATE);
  }
}
